const SOURCE_LABELS: Record<string, string> = {
  dedust_v1: 'DeDust Classic',
  dedust_v2: 'DeDust CPMM v2',
  stonfi_v1: 'STON.fi v1',
  stonfi_v2: 'STON.fi v2',
  uranus: 'Uranus',
  blum: 'Blum',
  tonfun: 'TonFun',
  gaspump: 'Gaspump',
  stonks: 'sTONks',
  wils: 'Wils',
  aggregate: 'All pools',
  launchpad: 'Launchpad',
}

export function dexDisplayLabel(source?: string | null): string {
  if (!source) return '—'
  return SOURCE_LABELS[source] ?? source.replace(/_/g, ' ').toUpperCase()
}

export function poolDexDisplayLabel(dex?: string | null): string {
  if (dex === 'dedust_v2') return 'DeDust v2'
  return dexDisplayLabel(dex)
}

export function tradeSourceDisplayLabel(
  source?: string | null,
  sourceLabel?: string | null
): string {
  return sourceLabel || dexDisplayLabel(source)
}

export function pairDexDisplayLabel(dex?: string | null, dexLabel?: string | null): string {
  return dexLabel || poolDexDisplayLabel(dex)
}
